const en_hk = {
  common: {
    home: "Home",
    notGuest: "Not {{name}}?",
    goHome: "Go Home",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    update: "Update",
    delete: "Delete",
    back: "Back",
    all: "All",
    yes: "Yes",
    no: "No",
    maybe: "Maybe",
    menu: "Menu",
    inputAdjusted: "Some characters were removed because they cannot be saved.",
  },
  visitor: {
    browsing: "Browsing as a visitor",
    identify: "Tell us who you are",
  },
  home: {
    welcome: "Welcome to Our Wedding",
    hello: "Hello, {{name}}!",
    switchGuest: "Not {{name}}? Switch",
    tagline: "Everything you need for our special day",
    identify: "Tell us who you are",
    invitation: "Invitation",
    invitationDesc: "View your wedding invitation and RSVP",
    programme: "Programme",
    programmeDesc: "View the wedding day schedule and timeline",
    gallery: "Gallery",
    galleryDesc: "Browse photos and videos from the wedding",
    upload: "Upload",
    uploadDesc: "Share your photos and videos from the day",
    countdown: {
      years: "Years",
      months: "Months",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
      untilWedding: "Until our wedding day",
      weddingDay: "Today is the day!",
      weddingPassed: "Thank you for celebrating with us!",
    },
  },
  identify: {
    title: "Who are you?",
    subtitle: "Please select your name so we can personalise your experience",
    currentlyIdentified:
      "You are currently identified as <strong>{{name}}</strong>",
    noGuests: "No guests found in this group",
    searchPlaceholder: "Search by name",
    noSearchResults: "No guests match that name",
  },
  invitation: {
    togetherWithFamilies: "Together with their families",
    requestPleasure: "request the pleasure of the company of",
    atCelebration: "at their wedding celebration",
    kindlyRespond: "Kindly Respond",
    visitorName: "Our Guests",
    notFound: "Invitation not found. Please check your link.",
  },
  rsvp: {
    title: "RSVP",
    trackIndividually: "Track individually?",
    attending: "Attending?",
    willAttend: "Will you be attending?",
    yesAttending: "Yes, I'll be there!",
    notAttending: "Sorry, can't make it",
    notSure: "Not sure yet",
    guestCount: "Number of guests attending:",
    whoIsComing: "Who is coming?",
    selectAtLeastOne: "Select at least one guest.",
    dietary: "Dietary requirements",
    messageOptional: "Message (optional)",
    messageCouple: "Message for the couple (optional)",
    submit: "Submit RSVP",
    submitting: "Submitting...",
    submitFailed: "Failed to submit RSVP",
    submitFailedFor: "Failed to submit RSVP for {{name}}",
  },
  confirmation: {
    thankYou: "Thank You!",
    received:
      "Your RSVP has been received. We look forward to celebrating with you!",
    updateRsvp: "Update RSVP",
  },
  gallery: {
    title: "Wedding Gallery",
    noMedia: "No media found",
    video: "Video",
  },
  upload: {
    title: "Share Your Moments",
    subtitle: "Upload your photos and videos from the wedding",
    yourName: "Your Name",
    autoFilled: "Auto-filled from your identity",
    category: "Category",
    preWedding: "Pre-wedding",
    ceremony: "Ceremony",
    reception: "Reception",
    party: "Party",
    other: "Other",
    dragDrop: "Drag & drop files here",
    clickBrowse: "or click to browse",
    maxSize: "Images and videos up to 50 MB each",
    uploaded: "Uploaded",
    uploadCount: "Upload {{count}} file",
    uploadCount_other: "Upload {{count}} files",
    allUploaded: "All files uploaded successfully! Thank you for sharing.",
  },
  programme: {
    title: "Order of the Day",
    subtitle: "Here's what to expect on our special day",
  },
  notFound: {
    title: "Page Not Found",
    message: "Please check the link and try again.",
  },
  invitationNotFound: {
    title: "Invitation Not Found",
    message: "Please check the link in your invitation and try again.",
  },
  admin: {
    panel: "Admin Panel",
    weddingAdmin: "Wedding Admin",
    wa: "WA",
    login: {
      title: "Wedding Admin",
      subtitle: "Sign in with your admin credentials",
      email: "Email",
      password: "Password",
      signIn: "Sign In",
      sessionEnded: "Your session ended",
      sessionEndedHint: "Sign in to keep this page. What you already typed is still here.",
      staySignedIn: "Stay signed in",
      staySignedInHint: "This page has been idle and the login will end soon.",
    },
    logout: "Logout",
    nav: {
      dashboard: "Dashboard",
      guests: "Guests",
      invitations: "Invitations",
      programme: "Programme",
      media: "Media",
      settings: "Settings",
      sitePhotos: "Site Photos",
      locale: "Locale",
      categories: "Categories",
    },
    dashboard: {
      title: "Dashboard",
      totalGuests: "Total Guests",
      invitations: "Invitations",
      rsvps: "RSVPs",
      mediaFiles: "Media Files",
      rsvpBreakdown: "RSVP Breakdown",
      attending: "Attending:",
      notAttending: "Not Attending:",
      maybe: "Maybe:",
      confirmedGuestCount: "Confirmed Guest Count",
      guestsConfirmed: "guests confirmed",
    },
    settings: {
      title: "Settings",
      guestDetailLevel: "GUEST DETAIL LEVEL",
      guestDetailLevelTooltip:
        "Controls how RSVP attendance is tracked — by party (group), by individual member, or let each party choose.",
      partyLevel: "Party-level — Track attendance by party only",
      memberLevel: "Member-level — Track individual members in each party",
      flexible: "Flexible — Let each party choose their preference",
      defaultMode: "Default mode for parties",
      party: "Party",
      member: "Member",
      defaultLanguage: "DEFAULT LANGUAGE",
      defaultLanguageTooltip:
        "Language used when a visitor's device language cannot be detected.",
      english: "English",
      chinese: "繁體中文",
      coupleNames: "COUPLE NAMES",
      coupleNamesZh: "Couple Names (Chinese)",
      weddingVenue: "WEDDING VENUE",
      weddingVenueZh: "Wedding Venue (Chinese)",
      mediaCategories: "MEDIA CATEGORIES",
      mediaCategoriesDescription:
        "Categories available for media uploads. Changes apply to new uploads and category edits.",
      addCategory: "Add Category",
      categoryExists: "Category already exists",
      categoryAdded: "Category added",
      categoryRemoved: "Category removed",
      idleTimeout: "ADMIN IDLE TIMEOUT",
      idleTimeoutTooltip:
        "Minutes without a request before an admin login ends. Guest visits are not affected.",
      idleTimeoutMinutes: "Minutes",
      idleTimeoutInvalid: "Enter a whole number from 5 to 10080.",
      idleTimeoutSaved: "Idle timeout saved",
      visitorMode: "Visitor mode",
      visitorModeTooltip:
        "When on, guests can open every page without choosing a name. Upload asks them to type a name.",
    },
    guests: {
      title: "Guests",
      orderHint:
        "Order applies within each group and is what guests see when they identify themselves.",
      selectGroupPrompt: "Choose a group to edit its parties.",
      noPartiesInGroup: "This group has no parties.",
      maxAttendeesTooLow:
        "Max attendees cannot be less than the number of members.",
      addGuest: "Add Guest",
      editGuest: "Edit Guest",
      name: "Name",
      nameZh: "Name (Chinese)",
      invitationCardName: "Invitation card text",
      invitationCardNameZh: "Invitation card text (Chinese)",
      invitationCardNameHint:
        "Shown on the invitation card for that language. A blank invitation line uses that language's party name. If that is also blank, the other language's invitation text is used, then its party name.",
      nameRequired: "Enter an English or Chinese name",
      group: "Group",
      maxAttendees: "Max Attendees",
      attending: "Attending",
      count: "Count",
      dietary: "Dietary",
      message: "Message",
      device: "Device",
      responded: "Responded",
      groups: "Groups",
      addGroup: "Add Group",
      editGroup: "Edit Group",
      noGroup: "(no group)",
      detailLevel: "Detail Level",
      members: "Members",
      addMember: "Add Member",
      editMember: "Edit Member",
      memberName: "Member Name",
      memberNameZh: "Member name (Chinese)",
      dietaryPreferences: "Dietary Preferences",
      confirmDelete: "Are you sure you want to delete this guest?",
      confirmDeleteGroup: "Are you sure you want to delete this group?",
      confirmDeleteMember: "Are you sure you want to delete this member?",
      parentGroup: "Parent Group",
      none: "None",
      moveUp: "Move up",
      moveDown: "Move down",
      dragToReorder: "Drag to reorder",
      copyCode: "Copy code",
      email: "Email",
      phone: "Phone",
      notes: "Notes",
      manageGroups: "Manage Groups",
      addRootGroup: "Add Root Group",
      memberRsvps: "Member RSVPs",
      actions: "Actions",
      detailLevelFlexible: "Detail Level (Flexible mode)",
      useDefault: "Use default",
      partyMembers: "Party Members",
      newMemberName: "New member name",
      deletedGroup: "Deleted group",
      groupDeletedReassign:
        "Group has been deleted. Please reassign this guest.",
      nonLeafReassign:
        "Guest is assigned to a non-leaf group. Please reassign.",
      seeMembers: "(see members)",
      icon: "Icon",
      iconNone: "None",
      iconEmoji: "Emoji",
      iconReact: "React icon",
      iconSvg: "SVG",
      iconImage: "Image",
      iconReactName: "Icon name, such as GiDiamondRing",
      iconReactMissing: "That icon was not found",
      iconSvgInvalid: "That SVG is not allowed",
      iconImageNeedsSave: "Save this record before uploading an image",
      iconClear: "Clear icon",
      iconUpload: "Upload image",
    },
    invitations: {
      title: "Invitations",
      generate: "Generate Links",
      generateAll: "Generate All",
      code: "Code",
      guest: "Guest",
      status: "Status",
      link: "Link",
      copyLink: "Copy Link",
      copied: "Copied!",
      sent: "Sent",
      pending: "Pending",
      opened: "Opened",
    },
    programme: {
      title: "Programme",
      addEvent: "Add Event",
      editEvent: "Edit Event",
      eventTitle: "Title",
      description: "Description",
      startTime: "Start Time",
      endTime: "End Time",
      location: "Location",
      sortOrder: "Sort Order",
      titleZh: "Title (Chinese)",
      descriptionZh: "Description (Chinese)",
      hide: "Hide",
      hidden: "Hidden",
      showOnInvitation: "Show on invitation",
      onInvitation: "Invitation",
      hiddenOffInvitation: "A hidden event stays off the invitation card.",
    },
    media: {
      title: "Media",
      approve: "Approve",
      reject: "Reject",
      deleteSelected: "Delete Selected",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      uploadedBy: "Uploaded by",
      category: "Category",
      noMedia: "No media files",
      search: "Search by filename or guest",
      filterCategory: "Category",
      filterStatus: "Status",
      filterModeration: "Moderation",
      allCategories: "All Categories",
      allStatuses: "All Statuses",
      allModeration: "All",
      showHidden: "Show hidden",
      featuredOnly: "Featured only",
      preview: "Preview",
      download: "Download",
      downloadZip: "Download ZIP",
      copyUrl: "Copy URL",
      urlCopied: "URL copied to clipboard",
      editCategory: "Edit Category",
      regenerateThumbnail: "Regenerate Thumbnail",
      delete: "Delete",
      confirmDelete: "Are you sure you want to delete this media?",
      confirmBulkDelete:
        "Are you sure you want to delete {{count}} selected items?",
      toggleFeatured: "Toggle Featured",
      toggleHidden: "Toggle Hidden",
      featured: "Featured",
      hidden: "Hidden",
      visible: "Visible",
      bulkChangeCategory: "Change Category",
      bulkApprove: "Approve Selected",
      bulkReject: "Reject Selected",
      nSelected: "{{count}} selected",
      clearSelection: "Clear Selection",
      noResults: "No results found",
      totalFiles: "Total Files",
      totalSize: "Total Size",
      storageUsed: "Storage Used",
      storageQuota: "of {{quota}} GB",
      pendingModeration: "Pending Review",
      stuckUploads: "Stuck Uploads",
      stuckAlert: "{{count}} uploads are stuck or failed",
      cleanUp: "Clean Up",
      cleanedUp: "Cleaned up {{count}} stuck uploads",
      uploadTimeline: "Upload Timeline",
      topUploaders: "Top Uploaders",
      mediaTypes: "Media Types",
      recentActivity: "Recent Activity",
      guest: "Guest",
      uploads: "Uploads",
      size: "Size",
      file: "File",
      type: "Type",
      status: "Status",
      moderation: "Moderation",
      uploaded: "Uploaded",
      actions: "Actions",
      image: "Image",
      video: "Video",
      other: "Other",
      dashboard: "Dashboard",
      table: "Table",
      timeAgo: "{{time}} ago",
      deletedSuccess: "Media deleted",
      bulkDeletedSuccess: "{{count}} items deleted",
      bulkUpdatedSuccess: "{{count}} items updated",
      categoryUpdated: "Category updated",
      moderationUpdated: "Moderation status updated",
      thumbnailRegenerated: "Thumbnail regenerated",
      featuredUpdated: "Featured status updated",
      hiddenUpdated: "Visibility updated",
    },
    locale: {
      title: "Edit Translations",
      subtitle: "The boxes show the text in use now, for guests and the admin portal. Edit a box to override it.",
      search: "Search keys or text...",
      key: "Key",
      english: "English",
      chinese: "繁體中文",
      default: "Default",
      resetToDefault: "Reset to default",
      saved: "Translations saved",
      saveFailed: "Failed to save translations",
      modified: "modified",
      noResults: "No matching keys",
      variables: "Variables",
    },
    sitePhotos: {
      title: "Site Photos",
      subtitle: "Upload photos to decorate your wedding website pages",
      homeLogo: "Site Icon and Guest Header",
      homeHero: "Home Banner",
      homeBg: "Home Page Background",
      homeCardInvitation: "Home Invitation Button Background",
      homeCardProgramme: "Home Programme Button Background",
      homeCardGallery: "Home Gallery Button Background",
      homeCardUpload: "Home Upload Button Background",
      invitationCouple: "Invitation Couple Photo",
      invitationCardBg: "Invitation Card Background",
      programmeHeader: "Programme Page Banner",
      programmeBg: "Programme Page Background",
      galleryBg: "Gallery Page Background",
      uploadBg: "Upload Page Background",
      uploadPhoto: "Upload Photo",
      replacePhoto: "Replace",
      removePhoto: "Remove",
      noPhoto: "No photo set",
      eventPhoto: "Programme Event Photo",
    },
  },
} as const;

export default en_hk;
